exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2LpEv{margin-top:30px;padding-left:0;list-style-type:none;text-align:center}._2LpEv li{position:relative;padding-left:30px;text-align:left}._2LpEv li i:first-child{position:absolute;left:0}@media (max-width:480px){._2LpEv{margin:0 -30px;padding:15px;background:#afddb6}}._2LpEv li{margin:20px 0;font-size:.9em}", ""]);

// exports
exports.locals = {
	"licenseBenefits": "_2LpEv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/ProductPage/Features/Features.scss
// module id = 774
// module chunks = 2